import { AvatarV2 } from "@jds/core";

const AvatarView = (props) => {
  return (
    <>
      <AvatarV2
        size="xtra-xtra-large"
        kind="information"
        avatarKind={props.image ? "image" : "icon"}
        badgeBorder={false}
        informationBadgeIcon="IcEditPen"
        informationBadgeColor="neutral"
        {...props}
      />
    </>
  );
};

export default AvatarView;
